import React from "react";
import { graphql } from "gatsby";
import { Container } from "react-bootstrap";
import {ParallaxProvider, ParallaxBanner, ParallaxBannerLayer} from "react-scroll-parallax";
import "./parallaxImageBanner.scss";

export const ParagraphParallaxImageBanner = ({ node }) => {
  const {field_summary, field_attribution, relationships} = node;
  return (
    <ParallaxProvider>
      <div className="parallax-image-banner-container">
        <ParallaxBanner className="parallax-image-banner">
          <ParallaxBannerLayer image={relationships?.field_banner_image?.relationships?.field_media_image?.publicUrl} speed={-20} />

          <div className="parallax-image-credit">
            <Container className="general-container">
              <div className="parallax-image-credit-inner">
                <div className="parallax-image-credit-inner-content">
                  <div dangerouslySetInnerHTML={{__html: field_summary?.value}}/>
                  <p className="image-credit-text">{field_attribution}</p>
                </div>
              </div>
            </Container>
          </div>
        </ParallaxBanner>
      </div>
    </ParallaxProvider>
  );
};

export const fragment = graphql`
  fragment ParagraphParallaxImageBanner on paragraph__parallax_image_banner {
    field_attribution
    field_summary {
      value
    }
    relationships {
      field_banner_image {
        relationships {
          field_media_image {
            publicUrl
          }
        }
      }
    }
  }
`;
